import { translate } from "@/filters";
import { Config } from "@/model/config";
import { ToastMessage } from "@/service/toast-message";
import axios, { AxiosError } from "axios";
import * as env from "@/utils/globals";

export class Api {
  public static readonly flightRequestModifiedEventName: string =
    "flightRequestModified";
  private static instance: Api;
  private inFlightRequestCounter = 0;

  constructor(private config: Config, private toastMessage: ToastMessage) {}

  static getInstance(): Api {
    if (Api.instance == null) {
      Api.instance = new Api(env.getConfig(), ToastMessage.getInstance());
    }
    return Api.instance;
  }

  /**
   * Method which retrieves vacancies based on a set of parameters (filters) from the vacancies API endpoint.
   */
  findVacancies(searchParams: URLSearchParams): Promise<any[]> {
    this.startRequest();

    return axios
      .get(this.config.restBasePath.vacancies, {
        params: searchParams
      })
      .then(response => {
        return Promise.resolve(response.data);
      })
      .catch(error => {
        this.showErrorToastMessage("findProducts", error);
        console.error("Server responded with an error", {
          error: error,
          url: `${this.config.restBasePath.vacancies}`,
          location: "apiMixin"
        });
        return Promise.reject("Server responded with an error");
      })
      .finally(() => {
        this.finishRequest();
      });
  }

  private showErrorToastMessage(
    apiTranslationKey: string,
    error: AxiosError
  ): void {
    let statusCode = "unknown";
    if (error.response && error.response.status) {
      statusCode = error.response.status.toString(10);
    }
    this.toastMessage.add(
      translate(`toastMessage.api.error.${apiTranslationKey}`, statusCode)
    );
  }

  private startRequest() {
    this.inFlightRequestCounter++;
    this.flightRequestModified();
  }

  private finishRequest() {
    this.inFlightRequestCounter--;
    this.flightRequestModified();
  }

  private flightRequestModified(): void {
    if (!!Event.prototype && !!Event.prototype.constructor.name) {
      const event = new CustomEvent(Api.flightRequestModifiedEventName);
      document.dispatchEvent(event);
    } else {
      // Fallback to createEvent that IE11 supports
      // note: createEvent is deprecated. https://developer.mozilla.org/en-US/docs/Web/API/Document/createEvent
      const flightRequestModifiedEvent = document.createEvent("HTMLEvents");
      flightRequestModifiedEvent.initEvent(
        Api.flightRequestModifiedEventName,
        true,
        true
      );
      document.dispatchEvent(flightRequestModifiedEvent);
    }
  }
}
